import styled, { css } from 'styled-components'
import { Link as BaseLink } from 'react-router-dom'

export type ButtonType = 'main' | 'secondary' | 'light' | 'danger' | 'dark'
interface ButtonProps {
  variant: ButtonType
  disabled?: boolean
}

const mainCSS = css`
  background: ${({ theme }) => theme.colors.main};
  color: ${({ theme }) => theme.colors.white};
`
const secondaryCSS = css`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderSecondary};
`
const lightCSS = css`
  background: ${({ theme }) => theme.colors.backgroundLight};
`
const dangerCSS = css`
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.danger};
`
const darkCSS = css`
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.backgroundSecondary};
`

function getButtonStyle({ variant }: ButtonProps) {
  switch (variant) {
    case 'main':
      return mainCSS
    case 'secondary':
      return secondaryCSS
    case 'light':
      return lightCSS
    case 'danger':
      return dangerCSS
    case 'dark':
      return darkCSS
  }
}
const baseCSS = css`
  border-radius: 4px;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  height: 35px;
  line-height: 16px;
  text-transform: uppercase;
`

export default styled.button<ButtonProps>`
  ${baseCSS}
  ${getButtonStyle}

  &:disabled {
    opacity: 0.8;
    cursor: auto;
  }
`
export const Link = styled(BaseLink).withConfig({
  shouldForwardProp: (prop: PropertyKey) => 'variant' !== prop,
})<ButtonProps>`
  ${baseCSS}
  border: none;
  margin: 5px;
  padding: 8px;
  color: ${({ theme }) => theme.colors.white};
  ${getButtonStyle}
`
export const UnstyledButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;

  :focus {
    box-shadow: none;
    outline: none;
  }
`
